import {IUpdatable} from '@fantasmagames/core/src/update/_interfaces/IUpdatable';
import {UpdateManager} from '@fantasmagames/core/src/update/UpdateManager';

export abstract class Updatable implements IUpdatable {

	protected _updateManager: UpdateManager;
	protected _isPlaying: boolean;

	constructor(start: boolean = false) {
		start && this.start();
	}

	public start(): void {
		this._isPlaying = true;
	}

	public stop(): void {
		this._isPlaying = false;
		this._updateManager && this._updateManager.remove(this);
	}

	public abstract update(dt: number): void;

	public get updateManager(): UpdateManager {
		return this._updateManager;
	}

	public set updateManager(value: UpdateManager) {
		this._updateManager = value;
	}

	public get isPlaying(): boolean {
		return this._isPlaying;
	}
}


// WEBPACK FOOTER //
// ./@fantasmagames/core/src/update/Updatable.ts